export const iconFontAwesomeNumbers0 = (
	<i className="fa-solid fa-0"></i>
);
